<template>
  <span>
    <slot v-bind="{ zloading: loading, onClick: callFunction, show: !showCountdown }"></slot>
    <slot
      name="countdown"
      v-bind="{ show: showCountdown, delaytime: getTime, onCountdownEnd: onCountdownEnd }"
    ></slot>
  </span>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
export default {
  props: {
    cname: {
      require: true
    },
    delay: {
      default: 5
    }
  },
  data() {
    return {
      loading: false,
      showCountdown: false,
      delaylist: []
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    getTime() {
      if (this.delaylist.length == 0) return true
      else {
        var delayTime = this.delaylist.find((el) => {
          return el.pageid == this.selectedBot.pageid
        })
        if (delayTime) {
          var now = moment()
          var date = moment(delayTime.time)
          return parseInt(date.diff(now, 'seconds'))
        } else {
          return true
        }
      }
    }
  },
  mounted() {
    this.delaylist =
      this.$localStorage.get(this.cname) && this.$localStorage.get(this.cname) !== 'undefined'
        ? JSON.parse(this.$localStorage.get(this.cname))
        : []
    // if (state.delayImportUserTime.length == 0) return true
    // else {
    //   var delayTime = state.delayImportUserTime.find(el => {
    //     return el.pageid == state.selectedBot.pageid
    //   })
    //   if (delayTime) {
    //     var now = moment()
    //     var date = moment(delayTime.time)
    //     return parseInt(date.diff(now, 'seconds'))
    //   } else {
    //     return true
    //   }
    // }
  },
  methods: {
    onCountdownEnd() {
      this.showCountdown = false
    },
    async callFunction() {
      this.loading = true

      var time = moment().add(this.delay, 'seconds').format('YYYY-MM-DD HH:mm:ss')
      this.setDelay({
        pageid: this.selectedBot.pageid,
        time: time
      })
      this.showCountdown = true
      this.$emit('onLoad', {
        callback: () => {
          this.loading = false
        }
      })
    },
    setDelay(payload) {
      if (this.delaylist.length == 0) {
        this.delaylist.push(payload)
      } else {
        var index = this.delaylist.findIndex((el) => {
          return el.pageid == payload.pageid
        })
        if (index != -1) {
          this.$set(this.delaylist, index, payload)
        } else {
          this.delaylist.push(payload)
        }
      }
      this.$localStorage.set(this.cname, JSON.stringify(this.delaylist))
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/elements/Cooldown.vue